<template>
  <section class="content-current">
    <form action="#">
      <h4>اطلاعات شرکت، سازمان ، موسسه دولتی</h4>
      <div class="row">
        <div class="col-md-12"></div>
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="profileRelated.relationTypeId">
              <option
                v-for="item in relationTypes"
                :value="item.key"
                :key="item.key"
              >
                {{ item.value }}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <label class="select-label">سمت </label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input
              disabled="true"
              type="text"
              v-datepicker
              :value="convertDate(agenceData.createdDate)"
            />
            <label class="special-labels">تاریخ ایجاد</label>
            <span class="highlight"></span>
            <span class="bar"></span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input
              type="text"
              v-model="agenceData.name"
              @blur="$v.agenceData.name.$touch()"
              :class="{ invalid: $v.agenceData.name.$error }"
            />
            <label>نام </label>
            <span class="highlight"></span>
            <span class="bar"></span>

            <p
              class="text-danger"
              v-if="!$v.agenceData.name.required && $v.agenceData.name.$dirty"
            >
              لطفا نام را وارد کنید
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="agenceData.englishName" />
            <span class="highlight"></span>
            <span class="bar"></span>

            <label>نام به انگلیسی</label>
          </div>
        </div>

        <div class="col-md-4">
          <div class="group_mdi inputContainer">
            <div class="icon-position">
              <i class="icon_calendar icon-custom"></i>
            </div>
            <input
              type="text"
              class="date-pick"
              v-datepicker
              :value="convertDate(agenceData.registrationDate)"
              @change="
                agenceData.registrationDate = $event.detail.GregorianDate
              "
            />
            <label>تاریخ ثبت </label>
            <span class="highlight"></span>
            <span class="bar"></span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="agenceData.corporationIdentification" />
            <span class="highlight"></span>
            <span class="bar"></span>

            <label>شماره ثبت شرکت</label>
          </div>
        </div>

        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="agenceData.nationalNumber" />
            <label>شناسه ملی</label>
            <span class="highlight"></span>
            <span class="bar"></span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="profile.vatCode" />
            <span class="highlight"></span>
            <span class="bar"></span>

            <label>کد مالیات بر ارزش افزوده</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="profile.fiscalCode" />
            <span class="highlight"></span>
            <span class="bar"></span>

            <label>کد مالیاتی</label>
          </div>
        </div>
      </div>

      <hr />
      <h4>موقعیت</h4>
      <div class="row">
        <div class="col-md-4">
          <div class="select">
            <select
              class="select-text"
              v-model="countryId"
              @change="getStates(countryId)"
            >
              <option v-for="item in country" :value="item.id" :key="item.name">
                {{ item.name }}
              </option>
            </select>
            <span class="highlight"></span>
            <span class="bar"></span>

            <label class="select-label">کشور</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select
              class="select-text"
              v-model="stateId"
              @change="getCites(stateId)"
            >
              <option v-for="item in states" :value="item.id" :key="item.name">
                {{ item.name }}
              </option>
            </select>
            <label class="select-label">استان</label>
            <span class="highlight"></span>
            <span class="bar"></span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select
              class="select-text"
               v-model="profile.nationalityId">
                <option v-for="item in cites" :value="item.id" :key="item.name">
                  {{ item.name }}
                </option>
              </select>
              <label class="select-label">شهر</label>
            <span class="highlight"></span>
              
            </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>توضیحات</label>
            <textarea
              placeholder="توضیحات"
              rows="4"
              class="form-control"
              type="text"
              v-model="agenceData.notation"
            />
          </div>
        </div>
      </div>

      <hr />
    </form>
    <div class="btn-align">
      <button
        v-if="!isEditMode"
        type="submit"
        class="btn btn-primary"
        @click.prevent="RegisterAgency()"
        :disabled="$v.$invalid"
        :class="{ disabledBtn: $v.$invalid }"
      >
        ثبت
      </button>

      <button
        v-if="isEditMode"
        type="submit"
        class="btn btn-primary"
        @click.prevent="UpdateAgency()"
        :disabled="$v.$invalid"
        :class="{ disabledBtn: $v.$invalid }"
      >
        ویرایش
      </button>

      <button
        type="submit"
        class="btn btn-danger"
        @click.prevent="goBackToList"
      >
        بازگشت
      </button>
    </div>
  </section>
</template>

<script>
import Store from "../../views/profile/store/index";
import moment from "moment-jalaali";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CreateAgency",
  store: Store,
  validations: {
    agenceData: {
      name: { required },
    },
  },
  data() {
    return {
      sourceId: "",
      sourceProfileId: "",
      sourceType: "",
      createdDate: "",
      isEditMode: false,
      agenceData: {
        id: "",
        name: "",
        englishName: "",
        notation: "",
        registrationDate: null,
        nationalNumber: "",
        corporationIdentification: "",
        sourceType: 2,
      },

      profile: {
        id: "",
        creatorProfileID: "",
        status: 3, // درحال بررسی
        profileType: 2,
        name: "",
        fiscalCode: "",
        vatCode: "",
        nationalityId: null,
      },

      profileRelated: {
        id: "",
        relatedProfileId: "",
        relationTypeId: "",
      },

      relationTypes: [
        { key: 1, value: "مدیر عامل" },
        { key: 2, value: "معاون" },
        { key: 3, value: "مشاور" },
      ],
      now: moment(),
      country: [],
      states: [],
      cites: [],
      countryId: "",
      stateId: "",
      cityId: "",
    };
  },
  mounted() {
    const params = this.$route.params;
    this.sourceId = params.sourceId;
    this.sourceProfileId = params.sourceProfileId;
    this.sourceType = params.sourceType;

    this.getSourceId();
    this.getAllCountry();
    this.getUserId();
  },
  methods: {
    async getSourceId() {
      if (this.sourceId == undefined || this.sourceId == "")
        this.sourceId = this.$store.getters.GetSourceId;

      if (this.sourceId !== "") {
        this.fetchData();
        this.isEditMode = true;
      }
    },
    async getUserId() {
      await this.$store.dispatch("getUserId").then(() => {
        this.profile.creatorProfileID = this.$store.getters.GetUserId;
      });
    },
    convertDate(date) {
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");

      return pdate;
    },
    RegisterAgency() {
      this.profile.name = this.agenceData.name;

      this.profileRelated = {
        relatedProfileId: this.profile.creatorProfileID, // پروفایل سازنده آزانس
        relationTypeId: this.profileRelated.relationTypeId,
      };
      this.$store
        .dispatch("CreateSource", {
          profileModel: {
            creatorProfileID: this.profile.creatorProfileID,
            name: this.agenceData.name,
            englishName: this.agenceData.englishName,
            profileType: 2, //آژانس
            status: 3, // در حال بررسی
            vatCode: this.profile.vatCode,
            fiscalCode: this.profile.fiscalCode,
            sourceViewModel: [this.agenceData],
            profileRelationViewModel: [this.profileRelated],
            nationalityId: this.profile.nationalityId,
          },
        })
        .then((res) => {
          this.agenceData.id = res.responseData.id;
          this.profile.id = res.responseData.profileId;

          this.profileRelated.id = res.responseData.profileRelationId;
          this.$emit("activeTabs", 1);
          this.isEditMode = true;
          // alert("ثبت اطلاعات با موفقیت انجام گردید");
          this.$toast.success("ثبت اطلاعات با موفقیت انجام گردید", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        });
    },
    UpdateAgency() {
      this.$store
        .dispatch("UpdateAgency", {
          profileModel: {
            id: this.profile.id,
            name: this.agenceData.name,
            englishName: this.agenceData.englishName,
            fiscalCode: this.profile.fiscalCode,
            vatCode: this.profile.vatCode,
            nationalityId: this.profile.nationalityId,
          },
          sourceModel: this.agenceData,
          profileRelationModel: this.profileRelated,
        })
        .then(() => {
          this.$emit("activeTabs", 1);
          // alert("ویرایش اطلاعات با موفقیت انجام گردید");
          this.$toast.success("ویرایش اطلاعات با موفقیت انجام گردید", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        });
    },
    async fetchData() {
      const data = {
        sourceId: this.sourceId,
        sourceProfileId: this.sourceProfileId,
        sourceType: this.sourceType,
      };
      const result = await this.$store.dispatch("getSourceById", data);
      if (result != undefined) {
        if (result.nationalityId != null) {
          this.getLocationById(result.nationalityId).then((res) => {
            this.getCites(res.parentLocationId);

            this.getLocationById(res.parentLocationId).then((response) => {
              this.getStates(response.parentLocationId);
              this.stateId = response.id;

              this.getLocationById(response.parentLocationId).then(
                (response) => {
                  this.getAllCountry();
                  this.countryId = response.id;
                }
              );
            });
          });
        }

        Object.assign(this.agenceData, result);

        this.profile = {
          vatCode: result.vatCode,
          fiscalCode: result.fiscalCode,
          id: result.profileId,
          nationalityId: result.nationalityId,
        };

        this.profileRelated = {
          relationTypeId: result.relationTypeId,
          id: result.profileRelationId,
        };
      } else {
        this.goBackToList();
      }
    },
    async getAllCountry() {
      await this.$store.dispatch("getAllCountry").then((res) => {
        this.country = res;
        if (res.length != 0) {
          this.countryId = this.country.where((p) => p.name == "ایران")[0].id;
          this.getStates(this.countryId);
        }
      });
    },
    async getStates(id) {
      await this.$store.dispatch("getLocationByParentId", id).then((res) => {
        this.states = res;
        if (res.length == 0) {
          this.cites = [];
          this.profile.nationalityId = null;
        }
      });
    },
    async getCites(id) {
      await this.$store.dispatch("getLocationByParentId", id).then((res) => {
        this.cites = res;
        if (res.length == 0) this.profile.nationalityId = null;
      });
    },
    async getLocationById(id) {
      return await this.$store.dispatch("getLocationById", id);
    },
    goBackToList() {
      this.$router.push({ name: "userBusinessList" });
    },
  },
};
</script>

<style scoped>
.content section {
  border-top: 1px solid #e2e2e2 !important;
}

.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}

::v-deep .v-step.is-active .label .index[data-v-1a92c248] {
  background-color: #999999;
  color: #ffffff !important;
}

::v-deep .index[data-v-1a92c248] {
  width: 2.5rem;
  height: 2.5rem;
  color: #ffffff !important;
  border: 0px;
  font-size: 1rem;
}

::v-deep [data-v-378b8112] .index[data-v-1a92c248] {
  width: 2.5rem;
  height: 2.5rem;
  color: #999999 !important;
  border: 0px;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}

.icon-custom {
  margin-top: 40px;
  /* width: 60%; */
  text-align: left !important;
  float: left;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #ddd;
}
</style>